import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_component_is_mounted_300 } from '@/hooks/is_mounted/use_component_is_mounted_300';
import { use_slice_generation, use_slice_user } from '@/hooks/store/use_slices';
import i18n_generation from '@/locales/keys/i18n_generation.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { useTranslation } from 'react-i18next';
import { PLACEHOLDER_BUTTON__bar } from '../../pages/_base/buttons/PLACEHOLDER_BUTTON__bar';

export function UI_SHARED_BUTTON__prompt_use_english_tokens() {
  /*
   * STORE
   */
  const { t } = useTranslation(ENUM__i18n_namespace.GENERATION);

  const { user_settings } = use_slice_user(['user_settings']);
  const { generation_current } = use_slice_generation(['generation_current']);

  const { is_mounted } = use_component_is_mounted_300();

  const tooltip_title = t(
    user_settings.regional_use_english_tokens_in_prompt
      ? i18n_generation.settings.prompt.buttons.use_prompt_tokens_on_native_english
      : i18n_generation.settings.prompt.buttons.use_prompt_tokens_on_native_language,
    { language: user_settings.regional_language },
  );

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    let settingsNew = user_settings.clone({ regional_use_english_tokens_in_prompt: !user_settings.regional_use_english_tokens_in_prompt });

    await FN_USER_SETTINGS__update(settingsNew);
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return generation_current.is_in_progress;
  }

  /*
   * RENDERS
   */

  function render_button() {
    let text = user_settings.regional_use_english_tokens_in_prompt ? 'En' : user_settings.regional_language.capitalize();

    return <span className={`hover-animation text-sm ${is_mounted ? 'scale-100 opacity-100' : 'scale-50 opacity-0'}`}>{text}</span>;
  }

  /*
   * HTML
   */

  if (generation_current.is_stub()) return <PLACEHOLDER_BUTTON__bar />;
  if (user_settings.regional_language == ENUM__language_type.ENGLISH) return <PLACEHOLDER_BUTTON__bar />;

  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button variant="no-border-on-bar" disabled={is_disabled()} size="rect-10-5" {...{ onClick }}>
        {render_button()}
      </UI_PRIMITIVE__button>
    </UI_PRIMITIVE__tooltip>
  );
}
